import React, { useEffect } from 'react';
import Sidebar from './components/Sidebar';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import JobLists from './components/JobLists';
import AddJob from './components/AddJob';
import logo from './logo.svg'
function App() {

  return (
    <Router>
      <body>
        <nav className="max-w-[90rem] mx-auto py-4 fixed top-0 w-full left-1/2 -translate-x-1/2 px-4 md:px-0">
          <img src={logo} />
        </nav>
        <div className="max-w-[90rem] mx-auto px-4 sm:px-6 md:px-8 ">
          <Sidebar />
          <div className="lg:pl-[14rem]  mt-[5.8125rem]">
            <Routes>
              <Route path="/" element={<JobLists />}></Route>
              <Route path="/create" element={<AddJob />}></Route>
              <Route path="/edit/:jobId" element={<AddJob isEditing={true} />} />
            </Routes>

          </div>
        </div>
      </body>
    </Router>

  );
}

export default App;
